// extracted by mini-css-extract-plugin
export default {"project-item":"ProjectDetail_project-item__+9xUI","tech-spec":"ProjectDetail_tech-spec__09m8O","site":"ProjectDetail_site__-mCCD","btn":"ProjectDetail_btn__q-zPu"};